import Booster from '@ecs/booster';

Booster.initialize({
  page: {
    product: 'ecred',
  }
})


// WEBPACK FOOTER //
// ./src/booster.js